const openPromoUnavailable = require<string>("../shared/templates/open-promo-content-unavailable.html");
const promoUnavailable = require<string>("../shared/templates/free-promo-content-unavailable.html");
const promo = require<string>("../shared/templates/free-promo-content.html");
const openPromo = require<string>("../shared/templates/open-promo-content.html");
const restrictedPromo = require<string>("../shared/templates/restricted-promo-content.html");

let registerLink = require<string>("../shared/templates/register-link.html");
let upgradeLink = require<string>("../shared/templates/hubspot-upgrade-link.html");
let upgradeButton = require<string>("../shared/templates/hubspot-upgrade-button.html");
let registerButton = require<string>("../shared/templates/hubspot-register-button.html");

// These values come from webpack DefinePlugin, which are populated by build definition variables.
registerLink = registerLink.replace("$RegisterLink", RegisterLink);
registerButton = registerButton.replace("$RegisterLink", RegisterLink);
upgradeLink = upgradeLink.replace("$UpgradeLink", UpgradeLink);
upgradeButton = upgradeButton.replace("$UpgradeLink", UpgradeLink);

const partials = {
        "free-promo-content": promo,
        "open-promo-content": openPromo,
        "restricted-promo-content": restrictedPromo,
        "free-promo-content-unavailable": promoUnavailable,
        "open-promo-content-unavailable": openPromoUnavailable,
        "register-link": registerLink,
        "register-button": registerButton,
        "upgrade-button": upgradeButton,
        "upgrade-link": upgradeLink,
};

Marionette.Renderer.render = (template, data) => {
    return Mustache.render(template, { Model: data }, partials);
};

export default Marionette;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/marionette-mustache.ts